import React from "react";
import s from "../../style/loading.module.css";

const Loading = () => {
  return (
    
      <div className={s.circ}>
        <div className={s.load}>Loading . . . </div>
        <div className={s.hands}></div>
        <div className={s.body}></div>
        <div className={s.head}>
          <div className={s.eye}></div>
        </div>
      </div>
    
  );
};

export default Loading;